import request from '../helpers/request'

export default {
  subscribe: async (url, payload) => {
    const { data } = await request.post(url, payload)

    return data
  }
}
